import { AdminBoostRes } from "../../types/admin-types/adminTypes";
import { API_ROUTES } from "../apiRoutes";
import axiosInstance from "../axiosInstance";

const BASE_URL = API_ROUTES.ADMIN;

// Get the token dynamically (in case it changes)
const getToken = () => sessionStorage.getItem("authToken");

export const getUsers = async (userType: string, payload: any) => {
  if (userType === "sellers") {
    return getSellers(payload);
  } else if (userType === "admins") {
    return getAdmins(payload);
  }
};

export const getSellers = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/read-sellers`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching sellers list", error);
    throw error;
  }
};

export const getAdmins = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/read-admins`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching admins list", error);
    throw error;
  }
};

export const verifyUser = async (userType: string, payload: any) => {
  if (userType === "sellers") {
    return verifySeller(payload);
  } else if (userType === "admins") {
    return verifyAdmin(payload);
  }
};

export const verifySeller = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/verify-seller`,
      payload,
      configs
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching sellers list", error);
    throw error;
  }
};

export const verifyAdmin = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/verify-admin`,
      payload,
      configs
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching admins list", error);
    throw error;
  }
};

export const getClassifieds = async (adType: string, payload: any) => {
  if (adType === "newClassifieds") {
    return getNewClassifieds(payload);
  } else if (adType === "editClassifieds") {
    return getEditClassifieds(payload);
  }
};

export const getNewClassifieds = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/read-new-ads`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching new classified list", error);
    throw error;
  }
};

export const getEditClassifieds = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/read-ad-edits`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching edit classified list", error);
    throw error;
  }
};

export const approveClassifieds = async (
  classifiedType: string,
  payload: any
) => {
  if (classifiedType === "newClassifieds") {
    return approveNewClassifieds(payload);
  } else if (classifiedType === "editClassifieds") {
    return approveEditClassifieds(payload);
  }
};

export const approveNewClassifieds = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/approve-new-ad`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching edit classified list", error);
    throw error;
  }
};

export const approveEditClassifieds = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/approve-ad-edit`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching edit classified list", error);
    throw error;
  }
};

export const getBoostRequestedClassifieds = async (
  payload: any
): Promise<AdminBoostRes> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/read-boost-requests`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching edit classified list", error);
    throw error;
  }
};

export const approveBoostRequest = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/approve-boost-request`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error fetching edit classified list", error);
    throw error;
  }
};

export const getThirdPartyAds = async (adSpaceId: any): Promise<any> => {
  try {
    let adSpaceURL = `${BASE_URL}/banners`;
    if (adSpaceId) {
      adSpaceURL = `${adSpaceURL}?id=${adSpaceId}`;
    }
    const response = await axiosInstance.get(adSpaceURL);

    return response.data.data.BannerSpaces;
  } catch (error) {
    console.error("Error fetching third party ads:", error);
    throw error;
  }
};

export const updateThirdPartyAdImg = async (payload: any): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/update-banner`,
      payload,
      configs
    );

    return response.data;
  } catch (error) {
    console.error("Error updating third party ad:", error);
    throw error;
  }
};

export const getThirdPartyAdPresigndeUrl = async (
  payload: any
): Promise<any> => {
  try {
    const authToken = getToken();
    const configs = {
      headers: {
        Authorization: "Bearer " + authToken,
      },
    };
    const response = await axiosInstance.post(
      `${BASE_URL}/get-banner-upload-presigned-urls`,
      payload,
      configs
    );

    return response.data.data;
  } catch (error) {
    console.error("Error getting presigend URL for image:", error);
    throw error;
  }
};
